const middlewares = []

export default middlewares
